import type { ActionExecutor } from "../TriggerEngine.interfaces";
import PlaylistEventsManager from "../Devices/PlaylistEventsManager";
import { PlaylistEvents } from "../Devices/PlaylistEventsManager.interface";

/**
 * `PlaylistEvents.Play` es lo que pone la pantalla en "reproduciendo", así que
 * solo se emite cuando hay audio de verdad: con la lista vacía o entera
 * irreproducible `play(0)` devuelve `false` —y ya cerró la rotación con
 * `PlaylistEmpty`— y emitir igual volvía a prender el transporte encima de esa
 * limpieza. El reanudar sigue anunciándose como siempre, cuando reanuda.
 */
export const playlistPlay: ActionExecutor = async (radio, _config, { eventContext }) => {
  const paused = radio.Playlist.isPaused();

  if (paused === true) {
    // Keep the action pending until playback resumes; the engine queues later
    // events, while only this operation carries its causal context.
    if (await radio.Playlist.resume(eventContext)) {
      PlaylistEventsManager.emit(PlaylistEvents.Play);
    }

    return;
  }

  if (paused === undefined) {
    await radio.Playlist.update();

    if (await radio.Playlist.play(0, eventContext)) {
      PlaylistEventsManager.emit(PlaylistEvents.Play);
    }

    return;
  }

  // `false` = ya está sonando: el disparador no cambia nada, pero la señal
  // para la UI se mantiene.
  PlaylistEventsManager.emit(PlaylistEvents.Play);
};

export const playlistPause: ActionExecutor = (radio, _config, { eventContext }) => {
  radio.Playlist.pause(eventContext);
  PlaylistEventsManager.emit(PlaylistEvents.Pause);
};

export const playlistNext: ActionExecutor = async (radio, _config, { eventContext }) => {
  await radio.Playlist.nextTrack(eventContext);
};

export const playlistPrev: ActionExecutor = async (radio, _config, { eventContext }) => {
  await radio.Playlist.prevTrack(eventContext);
};
